import { render, staticRenderFns } from "./userPageSidebar.vue?vue&type=template&id=7821636a&scoped=true"
import script from "./userPageSidebar.vue?vue&type=script&lang=js"
export * from "./userPageSidebar.vue?vue&type=script&lang=js"
import style0 from "./userPageSidebar.vue?vue&type=style&index=0&id=7821636a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7821636a",
  null
  
)

export default component.exports